import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CourseService, Course } from '../../../../core/services/course.service';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  private courseService = inject(CourseService);
  kidsPrograms: Course[] = [];
  montessoriCourses: Course[] = [];

  ngOnInit() {
    const allCourses = this.courseService.getAllCourses();
    this.kidsPrograms = allCourses.filter(c => 
      ['advanced-abacus', 'handwriting-improvement', 'spoken-english', 'vedic-maths'].includes(c.slug)
    );
     const order = [
    'montessori-teacher-training',   // 👈 FIRST
    'diploma-montessori-primary',
    'diploma-montessori-elementary'
  ];
    this.montessoriCourses = allCourses.filter(c => 
      ['montessori-teacher-training', 'diploma-montessori-primary', 'diploma-montessori-elementary'].includes(c.slug)
    ).sort((a, b) => order.indexOf(a.slug) - order.indexOf(b.slug));
  }

  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  currentYear() {
    return new Date().getFullYear();
  }
}
